var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{attrs:{"headers":_vm.headers,"items":_vm.isLoading ? [] : _vm.items,"pagination":_vm.pagination},on:{"click:action":_vm.handleAction,"click:viewAction":function($event){return _vm.rowAction('view', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }